import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@mui/styles';
import { Field } from 'formik';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import get from 'lodash/get';

const useStyles = makeStyles(theme => ({
  uploadContainer: {
    padding: '2px 4px',
    margin: theme.spacing(0.5, 0, 2),
    display: 'flex',
    alignItems: 'center',
  },
  input: {
    display: 'none',
  },
  text: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
}));

const FileUploaderInput = ({ setFieldValue, name, document }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  let inputRef = useRef(null);
  const fileInput = `${name}Input`;
  const fileText = `${name}Text`;

  useEffect(() => {
    if (document) {
      setFieldValue(fileText, document.name);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateUploadData = (file, text) => {
    if (!file && inputRef.current) {
      inputRef = null;
    }

    setFieldValue(fileInput, file);
    setFieldValue(fileText, text);
  };

  const isDisabled = field => !field.value;

  return (
    <Paper className={classes.uploadContainer}>
      <input
        className={classes.input}
        id={name}
        name={name}
        type="file"
        ref={inputRef}
        onChange={event =>
          updateUploadData(
            event.currentTarget.files[0],
            get(event.currentTarget.files, '[0].name', ''),
          )
        }
      />
      <Field name={`${name}Text`}>
        {({ field }) => (
          <>
            <InputBase
              {...field}
              className={classes.text}
              placeholder={t('UPLOAD.NO_FILE_SELECTED')}
              readOnly
            />
            <IconButton
              type="submit"
              className={classes.iconButton}
              disabled={isDisabled(field)}
              onClick={() => updateUploadData(null, '')}
              size="large">
              <DeleteIcon />
            </IconButton>
          </>
        )}
      </Field>
      <label htmlFor={name}>
        <Button variant="contained" color="primary" component="span">
          {t('UPLOAD.BROWSE')}
        </Button>
      </label>
    </Paper>
  );
};

FileUploaderInput.defaultProps = {
  name: null,
  document: undefined,
};

FileUploaderInput.propTypes = {
  setFieldValue: PropTypes.func.isRequired,
  name: PropTypes.string,
  document: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.string,
  }),
};

export default FileUploaderInput;
